import React, { useEffect, useRef, useState } from 'react';
import { getPreSignedDocument } from 'services/document-service'; // Assuming same for web
import './UrlImage.css'; // Add CSS for spinner or ellipsis
import { getCachedAsset } from 'common/utils/file-utils';

interface UrlImageProps {
  uri: string | null | undefined;
  fallbackSource?: string;
  style?: React.CSSProperties;
  height?: number;
  width?: number;
  fillColor?: string;
  signed?: boolean;
  onLoad?: () => void;
  classNames?: string;
  id?: string;
}

const UrlImage: React.FC<UrlImageProps> = ({
  uri,
  fallbackSource,
  style = {},
  height,
  width,
  fillColor,
  signed,
  onLoad,
  classNames,
  id,
}) => {
  const [imageUrl, setImageUrl] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  const loadImage = async () => {
    if (!uri) return;

    try {
      const result = await getCachedAsset(uri, 'image-assets-cache', signed);
      if (result instanceof Response) {
        const blob = await result.blob();
        const blobUrl = URL.createObjectURL(blob);
        setImageUrl(blobUrl);
      } else if (typeof result === 'string') {
        setImageUrl(result); // Already a URL
      }

      // setImageUrl(url);
    } catch (err) {
      console.error('[UrlImage] Error loading image:', err);
      setImageUrl(fallbackSource);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadImage();
  }, [uri, signed]);

  return (
    <div
      style={{
        position: 'relative',
        width: width ?? 'auto',
        height: height ?? 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...style,
      }}
      className={classNames}
      id={id}
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt="UrlImage"
          onLoad={() => {
            setLoading(false);
            onLoad?.();
          }}
          style={{
            height: height ?? 'auto',
            objectFit: 'cover',
            display: loading ? 'none' : 'block',
          }}
          className="urlImage"
        />
      )}

      {loading && (
        <div
          className="url-image-loader"
          style={{
            position: 'absolute',
            top: '40%',
            left: '45%',
            fontSize: '2rem',
            color: fillColor || '#999',
          }}
        >
          <span className="ellipsis">...</span>
        </div>
      )}
    </div>
  );
};

export default React.memo(UrlImage);
